import { render, staticRenderFns } from "./businessWalletCash.vue?vue&type=template&id=01d08b22&scoped=true&"
import script from "./businessWalletCash.vue?vue&type=script&lang=js&"
export * from "./businessWalletCash.vue?vue&type=script&lang=js&"
import style0 from "./businessWalletCash.vue?vue&type=style&index=0&id=01d08b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d08b22",
  null
  
)

export default component.exports